import { Component } from '@angular/core'

@Component({
  selector: 'se-po-edit-persona-docs',
  templateUrl: './edit-persona-docs.component.html',
  styleUrls: ['./edit-persona-docs.component.scss'],
  standalone: false,
})
export class EditPersonaDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public editPersonaComponent: any = [
    {
      Property: '@Input() profile',
      Type: 'UserProfile',
      Description: 'Profile to edit',
    }
  ]
}
